import { render } from "./BookLibrary.vue?vue&type=template&id=122212f2&scoped=true"
import script from "./BookLibrary.vue?vue&type=script&lang=js"
export * from "./BookLibrary.vue?vue&type=script&lang=js"

import "./BookLibrary.vue?vue&type=style&index=0&id=122212f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-122212f2"]])

export default __exports__